<template>
  <div>
    <div>
      <v-btn @click="$refs.imageInput.click()"> Select </v-btn>

      <v-btn @click="fileCleared"> Clear </v-btn>
      <input type="file" @change="preview_2" />
    </div>
    <div>
      <span>Selected file</span>
      <span v-if="imageSrc">{{ imageSrc.name }}</span>

      <div>
        <img id="imagefondo" :src="imgUrl" ref="imgg" />
      </div>
    </div>
  </div>
</template>
<script>
// let selectedFiles = null;
import Cropper from "cropperjs";

export default {
  data() {
    return {
      // imageInput,
      selectedFiles: null,
      imageSrc: null,
      cropper: {},
      cimage: {},
      imgUrl: "",
      // fileChanged,
      // fileCleared
    };
  },
  methods: {
    preview_2(event) {
      var outImage = "imagefondo";

      this.imgUrl = event.dataURL;
      if (FileReader) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (e) => {
          var image = new Image();
          image.src = e.target.result;
          // image.src = URL.createObjectURL(e)
          image.onload = () => {
            document.getElementById(outImage).src = image.src;
            // this.$refs.imgg.replace(image.src)

            this.gt();
          };
        };
      } else {
        // Not supported
      }
    },
    gt() {
      this.cimage = this.$refs.imgg;
      this.cropper = new Cropper(this.cimage, {
        zoomable: false,
        scalable: false,
        aspectRatio: 1,
      });
    },
    fileCleared() {
      this.selectedFiles = null;
    },
  },
};
</script>